<template>
    <div>
        <el-breadcrumb class="Breadcrumb" separator="/">
            <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item>后台用户管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="24">
                <el-col :span="6" :offset="0">
                    <el-input v-model="account" placeholder="请输入昵称/电话"></el-input>
                </el-col>
                <el-col :span="6" :offset="0">
                    <el-select v-model="roleId" filterable placeholder="请选择" style="width: 100%;">
                        <el-option v-for="item in roleSelect" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
                </el-col>
            </el-row>
        </div>
        <el-divider></el-divider>
        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="nickName" label="昵称">
                </el-table-column>
                <el-table-column prop="mobile" label="电话">
                </el-table-column>
                <el-table-column prop="roleName" label="角色名称">
                </el-table-column>
                <el-table-column label="启用/禁用">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isUsed" active-color="#13ce66" inactive-color="#ff4949"
                            :disabled="scope.row.canEdit == false" @change="changeDemo(scope.row.id, scope.row.isUsed)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="createdTate" label="创建时间">
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="openEdit(scope.row)" type="text" icon="el-icon-edit" size="small"
                            :disabled="scope.row.canEdit == false">编辑</el-button>
                        <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete" size="small"
                            :disabled="scope.row.canEdit == false">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>

        <!-- 添加弹窗-->
        <el-dialog :title="popTitle" :visible.sync="addPop" @close="resetForm('addUserPop')" :close-on-click-modal="false">
            <el-form :model="formDate" ref="addUserPop" label-width="80px" :rules="addUser">
                <el-form-item label="昵称" prop="nickName">
                    <el-input placeholder="请输入昵称" v-model="formDate.nickName"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="mobile">
                    <el-input placeholder="请输入电话" v-model="formDate.mobile"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="roleId">
                    <el-select v-model="formDate.roleId" filterable placeholder="请选择角色" style="width: 100%;">
                        <el-option v-for="item in roleSelect" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input placeholder="请输入密码" v-model="formDate.password" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPassword">
                    <el-input placeholder="请输入密码" v-model="formDate.checkPassword" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('addUserPop')">取 消</el-button>
                <el-button type="primary" @click="submitForm('addUserPop')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改弹窗-->
        <el-dialog :title="popTitle" :visible.sync="editPop" @close="resetForm('editUserPop')"
            :close-on-click-modal="false">
            <el-form :model="formDate" ref="editUserPop" label-width="80px" :rules="addUser">
                <el-form-item label="昵称" prop="nickName">
                    <el-input placeholder="请输入昵称" v-model="formDate.nickName"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input placeholder="请输入电话" v-model="formDate.mobile" disabled></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="roleId">
                    <el-select v-model="formDate.roleId" filterable placeholder="请选择角色" style="width: 100%;">
                        <el-option v-for="item in roleSelect" :key="item.id" :label="item.name" :value="parseInt(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('editUserPop')">取 消</el-button>
                <el-button type="primary" @click="submitForm('editUserPop')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    mounted() {
        this.getList();
        this.getSelectUser();
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (formName == 'addUserPop') {
                        this.addUserFun();
                    } else {
                        this.editUserFun();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            if (formName == 'addUserPop') {
                this.addPop = false
            } else {
                this.editPop = false
            }
        },
        //查询列表
        getList() {
            let data = {
                account: this.account,
                roleId: this.roleId,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            this.$get(api + "/adminUser/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        //获取角色下拉
        getSelectUser() {
            let data = {}
            this.$get(api + "/adminUser/getSelectRole", data).then(response => {
                let res = response.data;
                // console.log(response)
                if (res.code == 0) {
                    this.roleSelect = res.data;
                }
            })
        },
        //打开添加弹窗
        openAdd() {
            this.formDate = {};
            this.popTitle = '添加用户';
            this.addPop = true;
        },
        //添加User
        addUserFun() {
            let data = {
                nickName: this.formDate.nickName,
                mobile: this.formDate.mobile,
                roleId: this.formDate.roleId,
                password: this.formDate.password,
                checkPassword: this.formDate.checkPassword
            }
            this.$post(api + "/adminUser/addUser", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    })
                    this.addPop = false;
                    this.getListFun(1);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //打开编辑弹窗
        openEdit(ojb) {
            this.formDate = ojb;
            this.popTitle = '编辑用户';
            this.editPop = true;
        },
        //修改user
        editUserFun() {
            let data = {
                id: this.formDate.id,
                nickName: this.formDate.nickName,
                roleId: this.formDate.roleId,
            }
            this.$post(api + "/adminUser/editUser", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    this.editPop = false;
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },

        //删除User
        deleteFun(row) {
            this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {}
                this.$post(api + "/adminUser/delete/" + row, data).then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getListFun(1);
                    } else {
                        this.$message.error(res.desc);
                    }
                })
            }).catch(() => {

            });

        },
        //开启/关闭用户
        changeDemo(id, isUsed) {
            //true = 开启 false = 关闭
            let data = {}
            let uri = isUsed ? "enable" : "disable"
            let url = "/adminUser/" + uri + "/" + id;
            this.$post(api + url, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },

        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.pageNum = val;
        },

    },
    data() {
        var validateMobile = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else {
                const regex = /^1[3456789]\d{9}$/;
                if (regex.test(value)) {
                    return callback()
                } else {
                    return callback(new Error('请输入正确的手机号'))
                }
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if(value.length<8){
                callback(new Error('请输入最少8位的密码'));
            } else {
                if (this.formDate.checkPassword !== '') {
                    this.$refs.addUserPop.validateField('checkPassword');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.formDate.password) {
                callback(new Error('两次输入密码不一致!'));
            } else if(value.length<8){
                callback(new Error('请输入最少8位的密码'));
            } else {
                callback();
            }
        };
        return {
            //加载数据
            roleSelect: [],
            pageSize: 10,
            pageNum: 1,
            totalNum: 0,

            //查询条件
            account: '',
            roleId: '',
            //table数据
            tableData: [],
            //弹窗
            addPop: false,
            editPop: false,
            //标题
            popTitle: '',
            //表格数据
            formDate: {
                id: '',
                nickName: '',
                mobile: '',
                roleId: '',
                password: '',
                checkPassword: ''
            },
            addUser: {
                nickName: [
                    { required: true, message: '请输入用户昵称', trigger: 'blur' }
                ],
                mobile: [
                    { required: true,validator: validateMobile, trigger: 'change' }
                ],
                roleId: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ],
                password: [
                    { required: true,validator: validatePass, trigger: 'blur' }
                ],
                checkPassword: [
                    { required: true, validator: validatePass2, trigger: 'blur' }
                ]
            }
        };
    }
}

</script>


<style>
.Breadcrumb {
    _box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}


.el-row {
    margin-bottom: 20px;
}

.el-col {
    border-radius: 0px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 0px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/pages/sysset/user/AdminUser.vue